<style lang="scss" scoped>
  .menu {}
</style>

<template>
  <div class="menu">
    <el-menu
      :collapse="collapse"
      :default-active="activeItemName"
      active-text-color="#ff4f4f"
      background-color="#304156"
      text-color="#bfcbd9"
      @select="go">
      <template v-for="(item, i) of items">
        <menu-item :item="item" :key="i" :root="true"/>
      </template>
    </el-menu>
  </div>
</template>

<script>
import MenuItem from './menu-item.vue'

export default {
  name: 'menu',
  components: { MenuItem },
  props: {
    items: {
      type: Array,
      default () { return [] }
    },
    collapse: {
      default: false
    }
  },
  data () {
    return {
      activeItemName: this.$route.name,
    }
  },
  methods: {
    go (index) {
      this.$router.push({ name: index })
    }
  }
}
</script>
